var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.945,
    y2: 0.956,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M27,0A27,27,0,1,1,0,27,27,27,0,0,1,27,0Z",
    transform: "translate(1 2)",
    fill: "#eee"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287",
    transform: "translate(-1253 -973.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_67",
    "data-name": "Path 67",
    transform: "translate(1253 973.875)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28 1 C 24.35457992553711 1 20.81874084472656 1.713741302490234 17.49068832397461 3.121379852294922 C 14.27566909790039 4.481220245361328 11.38806915283203 6.42816162109375 8.908119201660156 8.908119201660156 C 6.42816162109375 11.38806915283203 4.481220245361328 14.27566909790039 3.121379852294922 17.49068832397461 C 1.713741302490234 20.81874084472656 1 24.35457992553711 1 28 C 1 31.64542007446289 1.713741302490234 35.18125915527344 3.121379852294922 38.50930786132812 C 4.481220245361328 41.72433090209961 6.42816162109375 44.61193084716797 8.908119201660156 47.09188079833984 C 11.38806915283203 49.57183837890625 14.27566909790039 51.51877975463867 17.49068832397461 52.87862014770508 C 20.81874084472656 54.28625869750977 24.35457992553711 55 28 55 C 31.64542007446289 55 35.18125915527344 54.28625869750977 38.50930786132812 52.87862014770508 C 41.72433090209961 51.51877975463867 44.61193084716797 49.57183837890625 47.09188079833984 47.09188079833984 C 49.57183837890625 44.61193084716797 51.51877975463867 41.72433090209961 52.87862014770508 38.50930786132812 C 54.28625869750977 35.18125915527344 55 31.64542007446289 55 28 C 55 24.35457992553711 54.28625869750977 20.81874084472656 52.87862014770508 17.49068832397461 C 51.51877975463867 14.27566909790039 49.57183837890625 11.38806915283203 47.09188079833984 8.908119201660156 C 44.61193084716797 6.42816162109375 41.72433090209961 4.481220245361328 38.50930786132812 3.121379852294922 C 35.18125915527344 1.713741302490234 31.64542007446289 1 28 1 M 28 0 C 43.46397018432617 0 56 12.53602981567383 56 28 C 56 43.46397018432617 43.46397018432617 56 28 56 C 12.53602981567383 56 0 43.46397018432617 0 28 C 0 12.53602981567383 12.53602981567383 0 28 0 Z",
    stroke: "none",
    fill: "#1fa4b6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "eyeglasses",
    d: "M10,7.5a5,5,0,1,1-5,5A5,5,0,0,1,10,7.5ZM16.563,8.87A7.5,7.5,0,0,0,2.6,11.253H1.25a1.25,1.25,0,0,0,0,2.5H2.6A7.5,7.5,0,0,0,17.5,12.5a2.5,2.5,0,1,1,5,0,7.5,7.5,0,0,0,14.9,1.25H38.75a1.25,1.25,0,0,0,0-2.5H37.4A7.5,7.5,0,0,0,23.438,8.87a5,5,0,0,0-6.875,0ZM35,12.5a5,5,0,1,1-5-5A5,5,0,0,1,35,12.5Z",
    transform: "translate(1261 989.877)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptica);
export default __webpack_public_path__ + "static/media/Optica.539199dabfa9d59b527710fdd70242d9.svg";
export { ForwardRef as ReactComponent };